module.exports = __webpack_public_path__ + "static/135-84d474ee367924e213cac2c6ada3c32b.jpg";